// export const baseURL = "http://localhost:8000";  // Local development
// export const baseURL = "https://app.k9scentgames.fun";  // Old developer's backend
export const baseURL = "https://k9backend-production.up.railway.app";  // Railway production
export const googleMapsApiKey = "AIzaSyA1Efom7xZ9wBPtQO4505DLguEcQ3i20xs";
